export const OFFER_FILTER_GROUPS = [
  {
    id: 'offer_details',
    label: 'Offer Details',
    filters: [
      {
        id: 'state',
        label: 'Status',
        type: 'checkbox',
        options: [
          { value: 'draft', label: 'Draft' },
          { value: 'pending', label: 'Pending' },
          { value: 'sent', label: 'Sent' },
          { value: 'accepted', label: 'Accepted' },
          { value: 'declined', label: 'Declined' },
        ]
      },
      {
        id: 'created_at',
        label: 'Created Date',
        type: 'date_range',
      },
      {
        id: 'owner',
        label: 'Created By',
        type: 'checkbox',
        options: [],
      },
      {
        id: 'buyer',
        label: 'Buyer',
        type: 'checkbox',
        options: [],
      },
      {
        id: 'act_type',
        label: 'Type',
        type: 'checkbox',
        options: [
          { value: 'headline', label: 'Headliner' },
          { value: 'support', label: 'Support' },
        ]
      },
      {
        id: 'event_date',
        label: 'Event Date',
        type: 'date_range',
      },
      {
        id: 'has_event',
        label: 'Event Status',
        type: 'checkbox',
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]
      },
      {
        id: 'has_holds',
        label: 'Holds',
        type: 'checkbox',
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]
      },
      {
        id: 'venue_name',
        label: 'Venue Name',
        type: 'checkbox',
        options: [],
      },
      {
        id: 'genre',
        label: 'Genre',
        type: 'checkbox',
        options: [],
      }
    ]
  }
];

export const getActiveFilterCount = (activeFilters) =>
  Object.values(activeFilters).reduce((count, v) => {
    if (Array.isArray(v) && v.length > 0) return count + 1;
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      if (v.start || v.end) return count + 1;
    }
    return count;
  }, 0);
